<script setup>
import { computed } from 'vue';
import Input from 'dashboard/components-next/input/Input.vue';

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: '',
  },
  variant: {
    type: String,
    default: 'default',
  },
});

const emit = defineEmits(['update:modelValue']);

const classMap = {
  default: '!h-9 !rounded-xl placeholder:!text-n-slate-9',
  settings:
    '!rounded-2xl placeholder:!text-n-slate-9 dark:!border-white/10 dark:!bg-[#0f172a] dark:!text-white dark:placeholder:!text-slate-400',
};

const resolvedClass = computed(
  () => classMap[props.variant] || classMap.default
);
</script>

<template>
  <Input
    :model-value="modelValue"
    :placeholder="placeholder"
    :custom-input-class="resolvedClass"
    @click.stop
    @update:model-value="emit('update:modelValue', $event)"
  />
</template>
